import {createAsyncThunk} from "@reduxjs/toolkit";
import { axiosInstance } from "../../../../utils/axios/requestInfo";
import { api } from "../../../../resources/api";

import {IProfile} from "./types";

export const fetchProfileInfo = createAsyncThunk<IProfile[]>(
  "getProfile/fetchGetProfileInfo",
  async () => {
    try {
      const response = await axiosInstance.get(api.profile.settings.getProfile.GET_PROFILE);
      if (response.data && !Array.isArray(response.data)) {
        return [response.data];
      }
      return response.data;
    } catch (error) {
      throw error;
    }
  }
);
